
export type SortOrder = number;
export let SortOrder: any = {};
SortOrder.Unsorted = 0;
SortOrder.Asc = 1;
SortOrder.Desc = -1;
SortOrder[SortOrder.Unsorted] = "Unsorted";
SortOrder[SortOrder.Asc] = "Asc";
SortOrder[SortOrder.Desc] = "Desc";

